import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { message } from 'antd'
import LoginPage from './pages/LoginPage'
import MainPage from './pages/MainPage'
import RegisterPage from './pages/RegisterPage'
import ProtectedRoute from './components/ProtectedRoute'
import { isLoggedIn } from './utils/auth'
import './styles/message.css'

// 简化message配置
message.config({
  top: 80,
  duration: 4,
  maxCount: 3,
});

function App() {
  const loggedIn = isLoggedIn() 
  
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={
          loggedIn ? <Navigate to="/memos" replace /> : <LoginPage />
        } />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/memos" element={
          <ProtectedRoute>
            <MainPage />
          </ProtectedRoute>
        } />
        <Route path="*" element={
          <Navigate to={loggedIn ? "/memos" : "/login"} replace />
        } />
      </Routes>
    </BrowserRouter>
  )
}

export default App